module.exports = __webpack_public_path__ + "static/img/IMG_20241028_080200.b1c173c6.jpg";